// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Lingui from "../../locales/Lingui.re.mjs";
import * as LangProvider from "./LangProvider.re.mjs";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as LocaleDetector from "../../lib/LocaleDetector.re.mjs";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Json$JsonCombinators from "@glennsl/rescript-json-combinators/src/Json.re.mjs";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as DetectLocale from "@lingui/detect-locale";
import * as Json_Decode$JsonCombinators from "@glennsl/rescript-json-combinators/src/Json_Decode.re.mjs";

function parse(json) {
  let decoder = Json_Decode$JsonCombinators.object(field => ({
    lang: field.optional("lang", Json_Decode$JsonCombinators.string),
    locale: field.optional("locale", Json_Decode$JsonCombinators.string)
  }));
  try {
    return Json$JsonCombinators.decode(json, decoder);
  } catch (exn) {
    return {
      TAG: "Error",
      _0: "An unexpected error occurred when checking the id."
    };
  }
}

let RouteParams = {
  parse: parse
};

let LoaderArgs = {};

let InvalidLanguageException = /* @__PURE__ */Primitive_exceptions.create("Lang.InvalidLanguageException");

function isInvalidLanguageError(error) {
  let exnId = error["RE_EXN_ID"];
  if (exnId === undefined) {
    return false;
  }
  let exnId$1 = Primitive_option.valFromOption(exnId);
  console.log(exnId$1);
  return String(exnId$1).includes("InvalidLanguageException");
}

async function loader(param) {
  let params = param.params;
  let validLangs = [
    "en",
    "ja",
    "th",
    "zh-TW",
    "zh-CN"
  ];
  let lang = params.lang;
  if (lang !== undefined && !validLangs.includes(lang)) {
    throw {
      RE_EXN_ID: InvalidLanguageException,
      _1: lang,
      Error: new Error()
    };
  }
  let lang$1 = Stdlib_Option.getOr(params.lang, "en");
  let locale = lang$1 === "ja" ? "jp" : "us";
  let tmp;
  if (import.meta.env.SSR) {
    let tmp$1 = lang$1 === "ja" ? LocaleDetector.jaFallback : LocaleDetector.enFallback;
    tmp = DetectLocale.detect(DetectLocale.fromNavigator({
      language: lang$1
    }), tmp$1);
  } else {
    let tmp$2 = lang$1 === "ja" ? LocaleDetector.jaFallback : LocaleDetector.enFallback;
    tmp = DetectLocale.detect(DetectLocale.fromNavigator(window.navigator), tmp$2).toLowerCase();
  }
  let detectedLocale = tmp;
  Lingui.i18n.activate(lang$1);
  let detectedLang = Stdlib_Option.flatMap(detectedLocale, LangProvider.parseLang);
  return {
    locale: locale,
    detectedLocale: Stdlib_Option.flatMap(detectedLocale, LangProvider.parseLocale),
    detectedLang: detectedLang,
    lang: lang$1,
    timezone: "America/Los_Angeles"
  };
}

let component = LangProvider.make;

export {
  RouteParams,
  LoaderArgs,
  InvalidLanguageException,
  isInvalidLanguageError,
  loader,
  component,
}
/* Lingui Not a pure module */
